"use strict";
// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var DataMessage_1 = require("../datamessage/DataMessage");
var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");
var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");
var BaseTask_1 = require("./BaseTask");
var SendAndReceiveDataMessagesTask = /** @class */ (function (_super) {
    __extends(SendAndReceiveDataMessagesTask, _super);
    function SendAndReceiveDataMessagesTask(context) {
        var _this = _super.call(this, context.logger) || this;
        _this.context = context;
        _this.taskName = 'SendAndReceiveDataMessagesTask';
        _this.sendDataMessageHandler = function (topic, data, // eslint-disable-line @typescript-eslint/no-explicit-any
        lifetimeMs) {
            if (_this.context.signalingClient.ready()) {
                var uint8Data = void 0;
                if (data instanceof Uint8Array) {
                    uint8Data = data;
                }
                else if (typeof data === 'string') {
                    uint8Data = new TextEncoder().encode(data);
                }
                else {
                    uint8Data = new TextEncoder().encode(JSON.stringify(data));
                }
                _this.validateDataMessage(topic, uint8Data, lifetimeMs);
                var message = SignalingProtocol_js_1.SdkDataMessagePayload.create();
                message.topic = topic;
                message.lifetimeMs = lifetimeMs;
                message.data = uint8Data;
                var messageFrame = SignalingProtocol_js_1.SdkDataMessageFrame.create();
                messageFrame.dataMessagePayloads = [message];
                _this.context.signalingClient.sendDataMessage(messageFrame);
            }
            else {
                throw new Error('Signaling client is not ready');
            }
        };
        return _this;
    }
    SendAndReceiveDataMessagesTask.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.context.removableObservers.push(this);
                this.context.signalingClient.registerObserver(this);
                this.context.realtimeController.realtimeSubscribeToSendDataMessage(this.sendDataMessageHandler);
                return [2 /*return*/];
            });
        });
    };
    SendAndReceiveDataMessagesTask.prototype.removeObserver = function () {
        this.context.realtimeController.realtimeUnsubscribeFromSendDataMessage(this.sendDataMessageHandler);
        this.context.signalingClient.removeObserver(this);
    };
    SendAndReceiveDataMessagesTask.prototype.handleSignalingClientEvent = function (event) {
        var e_1, _a;
        if (event.type === SignalingClientEventType_1.default.ReceivedSignalFrame &&
            event.message.type === SignalingProtocol_js_1.SdkSignalFrame.Type.DATA_MESSAGE) {
            try {
                for (var _b = __values(event.message.dataMessage.dataMessagePayloads), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var message = _c.value;
                    var dataMessage = new DataMessage_1.default(message.ingestTimeNs / 1000000, message.topic, message.data, message.senderAttendeeId, message.senderExternalUserId, message.ingestTimeNs === 0);
                    this.context.realtimeController.realtimeReceiveDataMessage(dataMessage);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    SendAndReceiveDataMessagesTask.prototype.validateDataMessage = function (topic, data, lifetimeMs) {
        if (!SendAndReceiveDataMessagesTask.TOPIC_REGEX.test(topic)) {
            throw new Error('Invalid topic');
        }
        if (data.length > SendAndReceiveDataMessagesTask.DATA_SIZE) {
            throw new Error('Data size has to be less than 2048 bytes');
        }
        if (lifetimeMs && lifetimeMs < 0) {
            throw new Error('The life time of the message has to be non negative');
        }
    };
    SendAndReceiveDataMessagesTask.TOPIC_REGEX = new RegExp(/^[a-zA-Z0-9_-]{1,36}$/);
    SendAndReceiveDataMessagesTask.DATA_SIZE = 2048;
    return SendAndReceiveDataMessagesTask;
}(BaseTask_1.default));
exports.default = SendAndReceiveDataMessagesTask;
//# sourceMappingURL=SendAndReceiveDataMessagesTask.js.map